import styled from "styled-components"

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
`
